import { render, staticRenderFns } from "./ApprovementDetail.vue?vue&type=template&id=889b43e4&scoped=true"
import script from "./ApprovementDetail.vue?vue&type=script&lang=js"
export * from "./ApprovementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889b43e4",
  null
  
)

export default component.exports